module.exports = __webpack_public_path__ + "img/Bg.6ddd1ebd.svg";